<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-center">
      <div class="copyright d-flex flex-wrap justify-content-center">
        <p class="m-0 text">Copyright &#169; Ricecurry Inc.</p>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
